// extracted by mini-css-extract-plugin
export default {"EditionTypeRdv":"EditionTypeRdv_EditionTypeRdv__i6Pg1","TypeRdv":"EditionTypeRdv_TypeRdv__-z1CB"};